import { Component, OnInit, ViewChild } from '@angular/core';
import { FavoritesList, PaginateDeploy } from '@cyborg-monorepo/hunter/common';
import { PageChangeEvent } from '@progress/kendo-angular-pager';
import { catchError, Observable, of, ReplaySubject } from 'rxjs';
import { DeploymentQueueComponent } from '../../../../../../shared/components/deployment-queue/deployment-queue';
import { HuntPackageComponent } from '../../../../../../shared/components/hunt-package/hunt-package.component';
import { CompanyService } from '../../../../../../shared/services/company.service';
import { UserService } from '../../../../../../shared/services/user.service';

@Component({ standalone: false, 
  selector: 'cyborg-my-env',
  templateUrl: './my-env.component.html',
  styleUrls: ['./my-env.component.scss'],
})
export class MyEnvComponent implements OnInit {
  @ViewChild(HuntPackageComponent) public huntPackage: HuntPackageComponent;
  @ViewChild(DeploymentQueueComponent)
  public deploymentQueue: DeploymentQueueComponent;
  public bookmarkedHuntPackages = 0;
  public huntPackagesUpdated: 0;
  public stagedHuntPackages$: Observable<PaginateDeploy>;
  public deployedHuntPackages$: Observable<PaginateDeploy>;
  public outdatedHuntPackages$: Observable<PaginateDeploy>;
  public error$: ReplaySubject<Error> = new ReplaySubject(1);
  public contentDetails: { title: string };
  public contentView: { content: Array<string> };
  public stagedSkip: number;
  public deployedSkip: number;
  public outdatedSkip: number;
  public page = 1;
  public pageSize = 10;
  public recent = false;

  public first: boolean = true;
  public second: boolean = false;
  public third: boolean = false;
  constructor(
    private companyService: CompanyService,
    private userService: UserService,
  ) {}

  public ngOnInit(): void {
    this.getHuntPackagesFavoritesCount();
    this.getStagedDeploys(this.pageSize, this.page);
    this.getDeployedDeploys(this.pageSize, this.page);
    this.getOutdatedDeploys(this.pageSize, this.page);
  }

  public onMarkForDeployedEvent(): void {
    this.getStagedDeploys(this.pageSize, this.page);
    this.getOutdatedDeploys(this.pageSize, this.page);
    this.getDeployedDeploys(this.pageSize, this.page);
  }

  private getStagedDeploys(size, page): void {
    this.stagedHuntPackages$ = this.companyService
      .getStagedDeploys(size, page)
      .pipe(
        catchError((error: Error) => {
          this.error$.next(error);
          return of(null);
        }),
      );
  }

  private getDeployedDeploys(size, page): void {
    this.deployedHuntPackages$ = this.companyService
      .getDeployedDeploys(size, page)
      .pipe(
        catchError((error: Error) => {
          this.error$.next(error);
          return of(null);
        }),
      );
  }

  private getOutdatedDeploys(size, page): void {
    this.outdatedHuntPackages$ = this.companyService
      .getOutdatedDeploys(size, page)
      .pipe(
        catchError((error: Error) => {
          this.error$.next(error);
          return of(null);
        }),
      );
  }

  private getHuntPackagesFavoritesCount(): void {
    this.userService
      .getFavorites(100, 1)
      .subscribe((favorites: FavoritesList) => {
        this.bookmarkedHuntPackages = favorites.meta.totalItems;
      });
  }

  public onStagedPageChange(e: PageChangeEvent): void {
    this.stagedSkip = e.skip;
    this.getStagedDeploys(this.pageSize, e.skip / this.pageSize + 1);
    this.first = true;
    this.second = this.third = false;
  }

  public onDeployedPageChange(e: PageChangeEvent): void {
    this.deployedSkip = e.skip;
    this.getDeployedDeploys(this.pageSize, e.skip / this.pageSize + 1);
    this.first = this.third = false;
    this.second = true;
  }

  public onOutdatedPageChange(e: PageChangeEvent): void {
    this.outdatedSkip = e.skip;
    this.getOutdatedDeploys(this.pageSize, e.skip / this.pageSize + 1);
    this.first = this.second = false;
    this.third = true;
  }
}
